// extracted by mini-css-extract-plugin
export default {"projectInfo":"ProjectInfo_projectInfo__+zGQh"};